import QuickQuestionComp from "./QuickQuestionComp";
import BackButtonComp from "./BackButtonComp";
import { useEffect, useState } from "react";
import TemplatesNotesBlogComp from "./TemplatesNotesBlogComp";
import TemplatesSelectionComp from "./TemplatesSelectionComp";
import BlueButtonComp from "./BlueButtonComp";
import SelectedNoteTempComp from "./SelectedNoteTempComp";
import { socketActions, socketSubActions } from "../../../helper/Websocket";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import "firebase/auth";
import "firebase/database";
import * as actions from "../../../redux/actions/auth.action";
import { bindActionCreators } from "redux";
import * as animationcong from "../image/congratulation_animation.json";
import { SignUpProvider } from "../actions/apis";
import { ShowAlert } from "../../../common/alert";
import Lottie from "react-lottie";
import messagesData from "../component/shared/ErrorSuccessMessages.json";
const defaultOptions = {
   loop: true,
   autoplay: true,
   animationData: animationcong,
   rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
   },
};

const SignUpComp = (props) => {
   const { history, step, setStep } = props;
   const [loading, setLoading] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [dataloading, setDataLoading] = useState(false);
   const [skiploading, setSkipLoading] = useState(false);
   const [templateList, setTemplateList] = useState([]);
   const [noteTypeArray, setNoteTypeArray] = useState([]);
   const [noteTypeKey, setNoteTypeKey] = useState([]);
   const selectOptionObj = {
      0: {
         header: "Patient Consultation:",
         title: ["After Visit Summary", "SOAP Note", "Standard Medical Note", "Standard Medical Note (Spanish)"],
      },
      1: {
         header: "Provider Notes:",
         title: [
            "Assessment and Plan",
            "ER Order",
            "SOAP Note",
            "Standard Medical Note",
            "Standard Medical Note (Spanish)",
         ],
      },
      2: { header: "In-Patient Notes:", title: ["Progress Note", "Rounding", "After Visit Summary"] },
      3: { header: "I want to pick note types myself", title: [] },
   };
   const header = step === 1 ? "Choose Templates" : "Note Types";
   const title = step === 1 ? "Choose the Note types you want to enable" : "We’ve enabled these Note types for you";
   const para = "You can change your templates or activate more in Settings";

   const getTemplatesData = () => {
      setIsLoading(true);
      let obj = {
         subAction: socketSubActions?.getTemplateList,
         action: socketActions?.onboarding,
      };
      window.socket.send(obj, (data) => {
         setIsLoading(false);
         setTemplateList(data);
      });
   };

   const regsitrationWithData = (step, setStep) => {
      setLoading(true);
      let obj = {
         action: socketActions?.onboarding,
         subAction: socketSubActions?.authenticateProvider,
         freemiumProviderChoices: {
            question: "Choose the Note types you want to enable",
            array: noteTypeArray,
            key: noteTypeKey,
         },
      };
      window.socket.send(obj, (resultStatus) => {
         setLoading(false);
         if (step === 1) {
            setStep((prevStep) => {
               return prevStep + 2;
            });
         } else {
            setStep((prevStep) => {
               return prevStep + 1;
            });
         }
         const message = resultStatus?.data;
         setTimeout(() => {
            SignUpProvider(message, history);
         }, 3000);
      });
   };

   const registationWithSkip = (step) => {
      setSkipLoading(true);
      let obj = {
         action: socketActions?.onboarding,
         subAction: socketSubActions?.authenticateProvider,
      };
      window.socket.send(obj, (resultStatus) => {
         setSkipLoading(false);
         setStep(step + 3);
         const message = resultStatus?.data;
         setTimeout(() => {
            SignUpProvider(message, history);
         }, 3000);
      });
   };

   const handleBackScreen = () => {
      if (step === 1) {
         setNoteTypeKey([]);
         setStep(step - 1);
      } else {
         setStep(step - 2);
      }
   };

   const noteTemplateIdFun = (id) => {
      let arr = noteTypeArray.map((s) => s);
      if (arr.some((s) => s === id)) {
         arr.splice(arr.indexOf(id), 1);
      } else {
         arr.push(id);
      }
      setNoteTypeArray(arr);
   };

   const stepOne = step === 1;

   useEffect(() => {
      getTemplatesData();
   }, [stepOne]);

   const handleGoNext = () => {
      if (noteTypeArray?.length === 0) {
         ShowAlert(messagesData.messages[4]?.selectOneTemplate, "error");
         return;
      } else {
         regsitrationWithData(step, setStep);
      }
   };

   useEffect(() => {
      window.addEventListener("keypress", handleKeyPressEvent);
      return () => {
         window.removeEventListener("keypress", handleKeyPressEvent);
      };
   }, []);

   const handleKeyPressEvent = (event) => {
      if (event.keyCode === 13 && event.key === "Enter") {
         const btn = document.getElementById("signUp-button-v2");
         if (btn) {
            btn.click();
         }
      }
   };

   return (
      <div className="vtwo-main-container-flex">
         <div className={`${step !== 3 && "vtwo-main-container"} d-relative`}>
            {step !== 3 && (
               <BackButtonComp
                  className="signup-back-icon"
                  onClick={() => {
                     if (step !== 1) {
                        handleBackScreen();
                     } else {
                        history.push("/");
                     }
                  }}
               />
            )}
            <div className="w-100 h-100">
               {/* {step === 0 && (
                  <div className="vtwo-center-container h-100 w-100">
                     <QuickQuestionComp
                        selectOptionObj={selectOptionObj}
                        getTemplatesData={getTemplatesData}
                        step={step}
                        setStep={setStep}
                        registationWithSkip={registationWithSkip}
                        skiploading={skiploading}
                        noteTypeKey={noteTypeKey}
                        setNoteTypeKey={setNoteTypeKey}
                     />
                  </div>
               )} */}
               {step === 1 && (
                  <div className="vtwo-temp-container-flex">
                     <TemplatesNotesBlogComp header={header} title={title} para={para} />
                     <div className="vtwo-center-container vtwo-temp-width">
                        <TemplatesSelectionComp
                           templateList={templateList}
                           noteTemplateIdFun={noteTemplateIdFun}
                           loading={isLoading}
                        />
                        <div className="d-flex justify-content-center">
                           <BlueButtonComp
                              id="signUp-button-v2"
                              btnText="Let’s Go"
                              fullWidth={true}
                              onClick={handleGoNext}
                              loading={loading}
                           />
                        </div>
                     </div>
                  </div>
               )}
               {step === 2 && (
                  <div className="vtwo-temp-container-flex">
                     <TemplatesNotesBlogComp header={header} title={title} para={para} />
                     <div className="vtwo-center-container">
                        <SelectedNoteTempComp noteTypeKey={noteTypeKey} selectOptionObj={selectOptionObj} />
                        <div className="d-flex justify-content-center">
                           <BlueButtonComp
                              btnText="Let's Go"
                              fullWidth={true}
                              onClick={() => regsitrationWithData(step, setStep)}
                              loading={loading}
                           />
                        </div>
                     </div>
                  </div>
               )}
               {step === 3 && (
                  <div className="vtwo-center-flex h-100 d-relative">
                     <div className="vtwo-cong-img">
                        <Lottie
                           options={defaultOptions}
                           height={"40%"}
                           width={"90%"}
                           isStopped={false}
                           isPaused={false}
                        />
                     </div>
                     <h1 className="vtwo-cong-text">Congratulations!</h1>
                  </div>
               )}
            </div>
         </div>
      </div>
   );
};

const mapDispatchToProps = (dispatch) => {
   return bindActionCreators(
      {
         savenorthwelluserobj: actions.savenorthwelluserobj,
         saveusercredentials: actions.saveusercredentials,
      },
      dispatch
   );
};

export default withRouter(connect(null, mapDispatchToProps)(SignUpComp));
